"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Immutable = require("immutable");
var sm = require("rwwa-rx-state-machine");
var Rx = require("rx");
/// DATA STATES ///
var State = /** @class */ (function () {
    function State() {
    }
    return State;
}());
exports.State = State;
var LoadingInstance = /** @class */ (function () {
    function LoadingInstance() {
    }
    return LoadingInstance;
}());
exports.LoadingInstance = LoadingInstance;
function isLoading(target) {
    return target === LoadingInstance;
}
exports.isLoading = isLoading;
var ErroredInstance = /** @class */ (function () {
    function ErroredInstance() {
    }
    return ErroredInstance;
}());
exports.ErroredInstance = ErroredInstance;
function isErrored(target) {
    return target === ErroredInstance;
}
exports.isErrored = isErrored;
function hasLoadedWithoutError(target) {
    return !!target && !isLoading(target) && !isErrored(target);
}
exports.hasLoadedWithoutError = hasLoadedWithoutError;
exports.hasErrored = isErrored;
function Map(seed) { return Immutable.Map().merge(seed); }
/// DATA ACCESS STATE ///
var Get = sm.createIntent('Get');
var Got = sm.createSignal('Got');
var LoadingErrorOccured = sm.createSignal('Error');
var Purge = sm.createSignal('Purge');
var Invalidate = sm.createSignal('Invalidate');
var RegisterType = sm.createSignal('RegisterType');
var UnRegisterType = sm.createSignal('UnRegisterType');
var InvalidateLoadedTimestamp = sm.createSignal('InvalidateLoadedTimestamp');
var fetchFns = {};
var mappingFns = {};
var maxToKeep = {};
var ownedByFns = {};
var hardTimeToLive = {};
var softTimeToLive = {};
var getQueue = {};
var timeoutHandle = null;
function enqueueGet(type, key, resetToLoading) {
    var arr = getQueue[type] = (getQueue[type] || []);
    arr.push({ key: key, resetToLoading: resetToLoading });
    if (!timeoutHandle) {
        timeoutHandle = setTimeout(dispatchBatchedGets, 16); // 16.666...ms pec frame @60fps
    }
}
function dedupeObjectArray(arrayOfObjects, keyToCheck) {
    return arrayOfObjects.filter(function (item, i) { return arrayOfObjects.findIndex(function (findItem) { return findItem[keyToCheck] === item[keyToCheck]; }) === i; });
}
exports.dedupeObjectArray = dedupeObjectArray;
function dispatchBatchedGets() {
    timeoutHandle = null;
    Object.keys(getQueue).forEach(function (type) {
        // De-dupe keys to avoid multiple fetches for same key in same queue
        var queuedItems = dedupeObjectArray(getQueue[type], 'key');
        Get({ type: type, queuedItems: queuedItems });
    });
    getQueue = {};
}
var accessOrderCount = 1;
var identity = function (i) { return i; };
function mapObj(obj, fn) {
    return Object.keys(obj).reduce(function (acc, key) {
        acc[key] = fn(obj[key], key);
        return acc;
    }, {});
}
var purgeQueue$ = new Rx.Subject();
function enqueuePurge() {
    purgeQueue$.onNext(null);
}
purgeQueue$.debounce(1000).subscribe(Purge);
function driver(state, sig) {
    if (state === void 0) { state = Map(); }
    switch (sig.tag) {
        case Get: {
            var _a = sig.data, queuedItems = _a.queuedItems, type_1 = _a.type;
            var fetch_1 = fetchFns[type_1];
            if (!fetch_1) {
                return state;
            }
            var typeState_1 = state.get(type_1);
            var keysToLoad_1 = queuedItems.filter(function (_a) {
                var key = _a.key;
                var wrapper = typeState_1.get(key);
                return !wrapper || !wrapper.isLoading;
            });
            return state.withMutations(function (mutableState) {
                keysToLoad_1.forEach(function (_a) {
                    var key = _a.key, resetToLoading = _a.resetToLoading;
                    if (resetToLoading) {
                        mutableState.setIn([type_1, key], createNewMutableWrapper());
                    }
                });
                fetch_1(keysToLoad_1.map(function (_a) {
                    var key = _a.key;
                    return key;
                }))
                    .subscribe(function (_a) {
                    var resultKeys = _a.keys, result = _a.result, error = _a.error;
                    result ? Got(result) : LoadingErrorOccured({ type: type_1, keys: resultKeys, error: error });
                });
            });
        }
        case Got: {
            var newState_1 = state;
            Object.keys(sig.data)
                .filter(function (typeKey) { return state.has(typeKey); })
                .forEach(function (typeKey) {
                var mapper = mappingFns[typeKey] || identity;
                var mapped = mapObj(sig.data[typeKey], mapper);
                Object.keys(mapped).forEach(function (key) {
                    var existing = state.getIn([typeKey, key]);
                    newState_1 = newState_1.setIn([typeKey, key], {
                        resource: mapped[key],
                        accessOrder: existing && existing.accessOrder || -1,
                        isLoading: false,
                        isErrored: false,
                        loadedTimestamp: new Date(),
                    });
                });
            });
            enqueuePurge();
            return newState_1;
        }
        case LoadingErrorOccured: {
            var _b = sig.data, type_2 = _b.type, keys = _b.keys, error_1 = _b.error;
            var result = keys.reduce(function (acc, key) {
                var value = state.getIn([type_2, key]);
                if (!value) {
                    return acc;
                }
                var updatedValue = __assign(__assign({}, value), { isLoading: false, isErrored: true, error: error_1 });
                return acc.setIn([type_2, key], updatedValue);
            }, state);
            return result;
        }
        case Invalidate: {
            var _c = sig.data, type = _c.type, key = _c.key;
            return state.deleteIn([type, key]);
        }
        case InvalidateLoadedTimestamp: {
            var newState = state;
            var _d = sig.data, key = _d.key, type = _d.type;
            var existing = state.getIn([type, key], null);
            if (existing) {
                var newValue = __assign(__assign({}, existing), { loadedTimestamp: new Date(1900, 0, 1) });
                newState = state.setIn([type, key], newValue);
            }
            return newState;
        }
        case RegisterType: {
            if (!state.get(sig.data)) {
                return state.set(sig.data, Map());
            }
            return state;
        }
        case UnRegisterType: {
            return state.delete(sig.data);
        }
        case Purge: {
            var purged = state.withMutations(function (mutableState) {
                mutableState.forEach(function (innerMap, type) {
                    var max = maxToKeep[type];
                    if (max && max < innerMap.size) {
                        var sortedResources = innerMap.sortBy(function (wrapper) { return -wrapper.accessOrder; });
                        mutableState.set(type, sortedResources.take(max).toMap());
                    }
                });
                mutableState.forEach(function (innerMap, type) {
                    var ownedByFn = ownedByFns[type];
                    if (ownedByFn) {
                        var remaining = innerMap.filter(function (value) { return mutableState.hasIn(ownedByFn(value.resource)); }).toMap();
                        mutableState.set(type, remaining);
                    }
                });
            });
            return purged;
        }
        default:
            return state;
    }
}
var state$ = sm.attachDriver({ path: 'rwwa-data-access', driver: driver });
function createNewMutableWrapper() {
    return {
        resource: null,
        accessOrder: accessOrderCount++,
        isLoading: true,
        isErrored: false,
        error: null,
        loadedTimestamp: new Date(),
    };
}
/// DECLARE RESOURCE TYPE ///
function destroyResourceType(type) {
    delete fetchFns[type];
    delete mappingFns[type];
    delete maxToKeep[type];
    delete ownedByFns[type];
    delete hardTimeToLive[type];
    delete softTimeToLive[type];
    UnRegisterType(type);
}
exports.destroyResourceType = destroyResourceType;
/// @fetchSingle - A function which fetches a single key.  The fetch can either resolve or fail.
///                If fetchMultiple is provided this is ignored.
/// @fetchMultiple - A function which accepts an array of keys.
///                  This function can return one or more 'chunks', each chunk represests a request for one or more keys and must either resolve or fail completely.
function declareResourceType(_a) {
    var type = _a.typeKey, fetchSingle = _a.fetchSingle, fetchMultiple = _a.fetchMultiple, fetchMultipleNoPromise = _a.fetchMultipleNoPromise, map = _a.map, ownedBy = _a.ownedBy, max = _a.maxToKeep, hardTtl = _a.hardTimeToLive, softTtl = _a.softTimeToLive;
    if (!type) {
        throw new Error('A typeKey must be specified for the type of resource');
    }
    if (ownedBy) {
        if (fetchSingle) {
            throw new Error('Both ownedBy and fetchSingle cannot be provided at the same time');
        }
        if (fetchMultiple) {
            throw new Error('Both ownedBy and fetchMultiple cannot be provided at the same time');
        }
        if (fetchMultipleNoPromise) {
            throw new Error('Both ownedBy and fetchMultipleNoPromise cannot be provided at the same time');
        }
        if (max) {
            throw new Error("Both ownedBy and maxToKeep(" + max + ") cannot be provided at the same time");
        }
        if (hardTtl) {
            throw new Error("Both ownedBy and hardTimeToLive(" + hardTtl + ") cannot be provided at the same time");
        }
        if (softTtl) {
            throw new Error("Both ownedBy and softTimeToLive(" + softTtl + ") cannot be provided at the same time");
        }
    }
    if ((fetchSingle || fetchMultiple) && fetchMultipleNoPromise) {
        throw new Error('If fetchMultipleNoPromise is provided, fetchSingle and fetchMultiple cannot be provided at the same time');
    }
    if (fetchMultipleNoPromise) {
        fetchFns[type] = fetchMultipleNoPromise;
    }
    else if (fetchSingle || fetchMultiple) {
        if (!fetchMultiple) {
            fetchMultiple = function (keys) { return Rx.Observable.fromArray(keys).map(function (key) {
                return {
                    keys: [key],
                    result: fetchSingle(key),
                };
            }); };
        }
        fetchFns[type] = function (keys) { return fetchMultiple(keys).selectMany(function (batch) {
            return batch.result
                .then(function (result) { return ({ keys: batch.keys, result: result }); })
                .catch(function (error) { return ({ keys: batch.keys, error: error }); });
        }); };
    }
    mappingFns[type] = map;
    maxToKeep[type] = max;
    ownedByFns[type] = ownedBy;
    hardTimeToLive[type] = hardTtl;
    softTimeToLive[type] = softTtl;
    RegisterType(type);
    function getFrom(state, key) {
        if (!key) {
            throw new Error('A key must be provided');
        }
        var wrapper = state.get(key);
        if (!wrapper || (!wrapper.isLoading && hasHardExpired(type, wrapper.loadedTimestamp))) {
            enqueueGet(type, key, true);
            return LoadingInstance;
        }
        if (wrapper.isLoading) {
            return LoadingInstance;
        }
        if (!wrapper.isLoading && hasSoftExpired(type, wrapper.loadedTimestamp)) {
            enqueueGet(type, key);
        }
        if (wrapper.isErrored) {
            return ErroredInstance;
        }
        wrapper.accessOrder = accessOrderCount++;
        return wrapper.resource;
    }
    var data$ = state$.select(function (data) { return data.get(type); });
    function getPromise(key) {
        return data$.select(function (state) { return getFrom(state, key); }).first(function (resource) { return !isLoading(resource); }).toPromise();
    }
    // Deprecate this function. Use remove OR invalidate depending on use case
    function hardInvalidate(state, key) {
        Invalidate({ type: type, key: key });
    }
    function remove(key) {
        Invalidate({ type: type, key: key });
    }
    function invalidate(key) {
        if (!key) {
            throw new Error('A key must be provided');
        }
        InvalidateLoadedTimestamp({ type: type, key: key });
    }
    return {
        __type_marker__: null,
        getFrom: getFrom,
        data$: data$,
        getPromise: getPromise,
        hardInvalidate: hardInvalidate,
        invalidate: invalidate,
        remove: remove,
        maxToKeep: max,
    };
}
exports.declareResourceType = declareResourceType;
function hasHardExpired(type, loadedTimestamp) {
    return hardTimeToLive[type] && dateToTimestampMs(loadedTimestamp) + hardTimeToLive[type] < dateToTimestampMs(new Date());
}
function hasSoftExpired(type, loadedTimestamp) {
    return softTimeToLive[type] && dateToTimestampMs(loadedTimestamp) + softTimeToLive[type] < dateToTimestampMs(new Date());
}
function dateToTimestampMs(date) {
    return +date;
}
